module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/core-js@2.6.12/~/core-js/library/modules/_add-to-unscopables.js
// module id = nI1h
// module chunks = 5